import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IReportFilterControl } from 'src/app/models';

@Component({
    selector: 'medpt-report-textbox',
    templateUrl: './textbox.component.html',
    styleUrls: ['./textbox.component.scss'],
    standalone: false
})
export class TextboxComponent implements OnInit {
  @Input() field!: IReportFilterControl;
  @Input() isMedPoint!: boolean;
  @Input() form!: FormGroup;
  @Output() filterChangeData = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }

}
